var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-input',_vm._g(_vm._b({attrs:{"type":_vm.type,"maxlength":_vm.maxlength
      ? _vm.maxlength
      : _vm.type === 'textarea'
      ? _vm.DESCRIPTION_MAX_LENGTH
      : _vm.type === 'integer' || _vm.type === 'decimal'
      ? _vm.NUMBER_INPUT_MAX_LENGTH
      : _vm.TITLE_MAX_LENGTH},on:{"input":_vm.valueInput,"blur":_vm.valueBlur},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(item,key){return {key:key,fn:function(){return [_vm._t(key)]},proxy:true}})],null,true),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'o-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }